"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAsync = exports.isValid = exports.isDirty = exports.isAborted = exports.OK = exports.DIRTY = exports.INVALID = exports.ParseStatus = exports.addIssueToContext = exports.EMPTY_PATH = exports.makeIssue = void 0;

var errors_1 = require("../errors");

var en_1 = __importDefault(require("../locales/en"));

var makeIssue = function makeIssue(params) {
  var data = params.data,
      path = params.path,
      errorMaps = params.errorMaps,
      issueData = params.issueData;
  var fullPath = [].concat(_toConsumableArray(path), _toConsumableArray(issueData.path || []));

  var fullIssue = _objectSpread(_objectSpread({}, issueData), {}, {
    path: fullPath
  });

  var errorMessage = "";
  var maps = errorMaps.filter(function (m) {
    return !!m;
  }).slice().reverse();

  var _iterator = _createForOfIteratorHelper(maps),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var map = _step.value;
      errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
      }).message;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return _objectSpread(_objectSpread({}, issueData), {}, {
    path: fullPath,
    message: issueData.message || errorMessage
  });
};

exports.makeIssue = makeIssue;
exports.EMPTY_PATH = [];

function addIssueToContext(ctx, issueData) {
  var issue = (0, exports.makeIssue)({
    issueData: issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [ctx.common.contextualErrorMap, ctx.schemaErrorMap, (0, errors_1.getErrorMap)(), en_1.default].filter(function (x) {
      return !!x;
    })
  });
  ctx.common.issues.push(issue);
}

exports.addIssueToContext = addIssueToContext;

var ParseStatus = /*#__PURE__*/function () {
  function ParseStatus() {
    _classCallCheck(this, ParseStatus);

    this.value = "valid";
  }

  _createClass(ParseStatus, [{
    key: "dirty",
    value: function dirty() {
      if (this.value === "valid") this.value = "dirty";
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.value !== "aborted") this.value = "aborted";
    }
  }], [{
    key: "mergeArray",
    value: function mergeArray(status, results) {
      var arrayValue = [];

      var _iterator2 = _createForOfIteratorHelper(results),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var s = _step2.value;
          if (s.status === "aborted") return exports.INVALID;
          if (s.status === "dirty") status.dirty();
          arrayValue.push(s.value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        status: status.value,
        value: arrayValue
      };
    }
  }, {
    key: "mergeObjectAsync",
    value: function () {
      var _mergeObjectAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(status, pairs) {
        var syncPairs, _iterator3, _step3, pair;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                syncPairs = [];
                _iterator3 = _createForOfIteratorHelper(pairs);
                _context.prev = 2;

                _iterator3.s();

              case 4:
                if ((_step3 = _iterator3.n()).done) {
                  _context.next = 17;
                  break;
                }

                pair = _step3.value;
                _context.t0 = syncPairs;
                _context.next = 9;
                return pair.key;

              case 9:
                _context.t1 = _context.sent;
                _context.next = 12;
                return pair.value;

              case 12:
                _context.t2 = _context.sent;
                _context.t3 = {
                  key: _context.t1,
                  value: _context.t2
                };

                _context.t0.push.call(_context.t0, _context.t3);

              case 15:
                _context.next = 4;
                break;

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t4 = _context["catch"](2);

                _iterator3.e(_context.t4);

              case 22:
                _context.prev = 22;

                _iterator3.f();

                return _context.finish(22);

              case 25:
                return _context.abrupt("return", ParseStatus.mergeObjectSync(status, syncPairs));

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 19, 22, 25]]);
      }));

      function mergeObjectAsync(_x, _x2) {
        return _mergeObjectAsync.apply(this, arguments);
      }

      return mergeObjectAsync;
    }()
  }, {
    key: "mergeObjectSync",
    value: function mergeObjectSync(status, pairs) {
      var finalObject = {};

      var _iterator4 = _createForOfIteratorHelper(pairs),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var pair = _step4.value;
          var key = pair.key,
              value = pair.value;
          if (key.status === "aborted") return exports.INVALID;
          if (value.status === "aborted") return exports.INVALID;
          if (key.status === "dirty") status.dirty();
          if (value.status === "dirty") status.dirty();

          if (typeof value.value !== "undefined" || pair.alwaysSet) {
            finalObject[key.value] = value.value;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return {
        status: status.value,
        value: finalObject
      };
    }
  }]);

  return ParseStatus;
}();

exports.ParseStatus = ParseStatus;
exports.INVALID = Object.freeze({
  status: "aborted"
});

var DIRTY = function DIRTY(value) {
  return {
    status: "dirty",
    value: value
  };
};

exports.DIRTY = DIRTY;

var OK = function OK(value) {
  return {
    status: "valid",
    value: value
  };
};

exports.OK = OK;

var isAborted = function isAborted(x) {
  return x.status === "aborted";
};

exports.isAborted = isAborted;

var isDirty = function isDirty(x) {
  return x.status === "dirty";
};

exports.isDirty = isDirty;

var isValid = function isValid(x) {
  return x.status === "valid";
};

exports.isValid = isValid;

var isAsync = function isAsync(x) {
  return typeof Promise !== "undefined" && x instanceof Promise;
};

exports.isAsync = isAsync;